import PlaceholderImage from '../../../atoms/placeholderImage/PlaceholderImage';
import LinkToWishlist from '@srcDS/components/molecules/linkToWishlist/LinkToWishlist';
import ProductImage from '../../cartPage/cartItem/components/ProductImage';
import ProductName from '../../cartPage/cartItem/components/ProductName';
import ProductOption from '../../cartPage/cartItem/components/ProductOption';
import ProductPrice from '../../cartPage/cartItem/components/ProductPrice';
import styles from './NostoList.module.scss';
import React, { Fragment, useMemo, useState } from 'react';
import { Link } from '../../../atoms/link/Link';
import { pricesForGroup } from '../../../../utils/helpers';
import SelectSize from '../../cartPage/cartItem/components/SelectSize';
import { getSortedSizeLabels } from '../../productActions/utils/sortOrder';
import Button from '../../../atoms/button';
import PrimaryLoader from '../../../atoms/primaryLoader/PrimaryLoader';
import clsx from 'clsx';
import { customClasses, wishListButtonText } from './_vars';

const NostoCartItem = ({
  item,
  capitalize,
  minimalView,
  setShowDialog,
  setLoading,
  toSignUp,
  handleAddToCart,
  loggedIn,
  customerGroupId,
}) => {
  const [selectedSize, setSelectedSize] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [statusMenu, setStatusMenu] = useState({ status: false, label: false });

  const {
    variants,
    url,
    projectSpecificData: { prices = [], vipPrices = [] },
    tags,
    productName,
    productId,
  } = item;

  const image = item?.images?.[0]?.url;

  const { price, discountedPrice, onSale } = pricesForGroup(prices, vipPrices, loggedIn, customerGroupId);

  const variantList = useMemo(() => {
    if (!variants) return [];
    let list = [];

    const data = variants
      .map((sku) => ({
        ...sku,
        label: sku.custom_fields?.size,
        value: sku.name,
        isOutOfStock: !sku?.available,
      }))
      .filter((sku) => !sku?.isOutOfStock);

    list = [...list, ...data];
    return getSortedSizeLabels(list);
  }, [variants]);

  const formatVariantList = useMemo(() => {
    return [{ value: '', label: 'Size', isHiddenFromDropdown: true }, ...variantList];
  }, [variantList]);

  const selectedVariants = selectedSize && item?.variants?.find((x) => x.sku === selectedSize);

  return (
    <div className={clsx(styles.cartItem, { [styles.cartItemMini]: minimalView })}>
      <div className={styles.product} id={productId}>
        <Link link={url} onClick={() => setShowDialog(false)}>
          {image ? (
            <ProductImage customClasses={{ productImage: styles.productImage }} alt={productName} image={image} />
          ) : (
            <div className={styles.productImage}>
              <PlaceholderImage />
            </div>
          )}
        </Link>
        <div className={styles.productContent}>
          <div className={styles.productNameWrap}>
            {productName && (
              <Link link={url} onClick={() => setShowDialog(false)}>
                <ProductName className={styles.productName} name={productName} />
              </Link>
            )}
          </div>
          <div className={styles.productOptions}>
            {tags?.map((tag, key) => {
              return (
                <Fragment key={key}>
                  {tags.length > 1 && key > 0 && <span className={styles.divider}>|</span>}
                  <ProductOption color={tag} capitalize={capitalize} />
                </Fragment>
              );
            })}
          </div>
          <div className={styles.priceWrap}>
            <ProductPrice placement="cart_not_bold" fullPrice={price} discountPrice={discountedPrice} onSale={onSale} />
            {!minimalView && (
              <LinkToWishlist
                item={{
                  productName: item?.productName,
                  productId: item?.productId,
                  variant: item?.variants?.find((x) => x.sku === selectedSize),
                }}
                lineItemId={productId}
                toSignUp={toSignUp}
                setLoading={setLoading}
                customClasses={{
                  linkToWishlist: styles.linkToWishlist,
                }}
                buttonText={wishListButtonText}
              />
            )}
          </div>
          <div className={styles.buttonsWrap}>
            {variantList?.length > 0 && (
              <SelectSize
                openToTop
                selectSizeVariant="normal"
                selectSizeLabelPosition="normal"
                defaultExpanded={statusMenu}
                options={formatVariantList}
                uniqueId={productId}
                customClasses={customClasses}
                onSelect={(e) => {
                  if (selectedSize !== e.target.value) {
                    setSelectedSize(e.target.value);
                  }
                }}
              />
            )}
            <Button
              type="submit"
              variant="primaryOutlined"
              className={customClasses.nostoItemButton}
              disableTouchEvent
              onClick={async () => {
                if (!selectedSize) {
                  return setStatusMenu((prev) => ({
                    status: true,
                    label: !prev.label,
                  }));
                }
                setButtonLoading(true);

                await handleAddToCart(
                  {
                    ...item,
                    name: item.productName,
                    price: selectedVariants?.price * 100,
                  },
                  {
                    ...selectedVariants,
                    imageUrl: selectedVariants.image_url,
                    projectSpecificData: item.projectSpecificData,
                    discountedPrice,
                    price,
                  },
                  () => setButtonLoading(false),
                  () => setButtonLoading(false),
                );
              }}
            >
              {buttonLoading ? <PrimaryLoader theme="dark" mode="segment" size={22} /> : 'Add to bag'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NostoCartItem;
